var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-checkbox-set" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.selectButtons,
            expression: "selectButtons",
          },
        ],
        staticClass: "field has-addons",
      },
      [
        _c("p", { staticClass: "control" }, [
          _c(
            "button",
            {
              staticClass: "button select-all",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.selectAll.apply(null, arguments)
                },
              },
            },
            [_vm._v(" Select all ")]
          ),
        ]),
        _c("p", { staticClass: "control" }, [
          _c(
            "button",
            {
              staticClass: "button clear-all",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.deselectAll.apply(null, arguments)
                },
              },
            },
            [_vm._v(" Clear all ")]
          ),
        ]),
      ]
    ),
    _c(
      "ul",
      _vm._l(_vm.options, function (ref) {
        var value = ref.value
        var label = ref.label
        return _c(
          "li",
          { key: value },
          [
            _c(
              "b-checkbox",
              {
                attrs: { "native-value": value },
                model: {
                  value: _vm.selected,
                  callback: function ($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected",
                },
              },
              [_vm._v(" " + _vm._s(label) + " ")]
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }